export const UPDATE_TAG_FAILURE = 'UPDATE_TAG_FAILURE';

export const updateTagFailure = (payload: Error) => ({
    type: UPDATE_TAG_FAILURE,
    payload,
    error: true,
});
